import parseNavigation from "./navigation-parser.js";

let cachedState = null;

function normalise(p) {
  return p.replace(window.location.origin, "").replace(/\/$/, "");
}

function findPath(nodes, currentPath, parents = []) {
  for (const node of nodes) {
    const nodePath = normalise(node.url);
    const newTrail = [...parents, node];

    if (nodePath === currentPath) {
      return newTrail;
    }

    if (node.children?.length) {
      const found = findPath(node.children, currentPath, newTrail);
      if (found) return found;
    }
  }

  return null;
}

export default function getNavigationState() {
  if (cachedState) return cachedState;

  const fullTree = parseNavigation();
  if (!fullTree.length) return null;

  const navTree = fullTree[0]?.children || [];

  const currentPath = normalise(
    document.body.dataset.current || window.location.pathname,
  );

  const trail = findPath(navTree, currentPath) || [];

  cachedState = {
    tree: navTree,
    trail,
    path: trail.map((n) => n.url),
    current: trail.at(-1),
    parent: trail.at(-2),
    section: trail.at(0),
  };

  return cachedState;
}
